import { getAllElements } from "@/request/api";
export default {
    state: {
        paramConfig: {},
        languageAll: '',
        arr: []
    },
    getters: {

    },
    actions: {
        setParams({ commit }, type) {
            let p = ''
            if (type === 1) {
                hydra.customPlugin({
                    action: "UtilPlugin.getAppConfig",
                    params: {},
                    success(res) {
                        p = res.data
                        commit('SET_PARAMS', JSON.parse(p))
                        localStorage.setItem('languageH5', JSON.parse(p).language);
                    },

                })
            }
            if (type === 2) {
                setTimeout(() => {
                    let params = {
                        inChina: "1",
                        language: "cn",
                        city: "1",
                        channelId: 'ad17d95ef7c84f309628a2421bd440e8'
                    };
                    p = params
                    localStorage.setItem('languageH5', params.language);
                    commit('SET_PARAMS', p);
                }, 10)
            }

            // console.log(type, 'type');
            // setTimeout(() => {
            //     let params = {
            //         inChina: "1",
            //         language: "cn",
            //         city: "1",
            //         channelId: 'ad17d95ef7c84f309628a2421bd440e8'
            //     };
            //     p = params
            //     localStorage.setItem('languageH5', params.language);
            //     commit('SET_PARAMS', p);
            // }, 10)
            // 提交mutation来更新状态
        },
        setLanguage({ commit }) {
            getAllElements().then(res => {
                if (res.flag) {

                    commit('SET_LANGE', res.data)
                }
            })
        }

    },
    mutations: {
        SET_PARAMS: (state, obj) => {
            state.paramConfig = obj;
        },
        SET_LANGE: (state, obj) => {
            state.languageAll = obj;
        }
    }
};